import { PANEL, getPanelStepRank } from "./panelTokens";
import {
  panelTableCardSx,
  panelStatsFilterFieldInnerSx,
  panelSummaryAvatarSx,
  panelPrimaryButtonSx,
} from "./panelCardSx";
import { PANEL_CHART } from "./panelChartSx";

export { panelSummaryAvatarSx };
export const panelStatsFilterHeaderIconSx = {
  width: 40,
  height: 40,
  borderRadius: "12px",
  bgcolor: PANEL.accent.soft12,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiSvgIcon-root": { color: PANEL.accent.text, fontSize: 22 },
};

export const panelStatsFilterTitleSx = {
  fontWeight: 800,
  color: PANEL.text.primary,
  fontSize: "1rem",
};

export const panelStatsFilterRefreshButtonSx = {
  bgcolor: PANEL.pageBg,
  border: `1px solid ${PANEL.border}`,
  color: PANEL.accent.text,
  "&:hover": {
    bgcolor: PANEL.accent.soft,
    transform: "rotate(180deg)",
  },
  transition: "all 0.4s ease",
};

export const panelStatsFilterLabelSx = {
  color: PANEL.text.muted,
  fontWeight: 600,
  fontSize: "0.875rem",
  "&.Mui-focused": { color: PANEL.accent.text },
  "&.MuiInputLabel-shrink:not(.Mui-focused)": { color: PANEL.text.muted },
};

export const panelStatsActiveFilterSectionSx = {
  pt: 2,
  borderTop: `1px solid ${PANEL.border}`,
};

export const panelStatsActiveFilterLabelSx = {
  color: PANEL.text.muted,
  fontWeight: 700,
  textTransform: "none",
  letterSpacing: "1px",
  fontSize: "0.7rem",
};

export const panelStatsActiveFilterChipSx = (variant = "entity") => {
  const variants = {
    entity: {
      bgcolor: PANEL.blue.soft12,
      color: PANEL.blue.text,
      border: `1px solid ${PANEL.blue.soft30}`,
    },
    metric: {
      bgcolor: PANEL.accent.soft12,
      color: PANEL.accent.text,
      border: `1px solid ${PANEL.accent.softBorder}`,
    },
    time: {
      bgcolor: PANEL.pageBg,
      color: PANEL.text.body,
      border: `1px solid ${PANEL.border}`,
    },
    groupBy: {
      bgcolor: PANEL.fill.muted,
      color: PANEL.text.muted,
      border: `1px solid ${PANEL.border}`,
    },
  };
  return {
    ...variants[variant],
    fontWeight: 600,
    height: 28,
    "& .MuiChip-icon": { color: "inherit", opacity: 0.85 },
    "&:hover": {
      transform: "scale(1.03)",
      transition: "transform 0.2s ease",
    },
  };
};

export const panelStatsCustomDateSectionSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
  gap: 2,
  alignItems: "start",
  mt: 2,
  pt: 2,
  borderTop: `1px solid ${PANEL.border}`,
};

export const panelExportExcelButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  alignSelf: "flex-start",
  bgcolor: PANEL.surface,
  color: PANEL.accent.text,
  px: 2,
  py: 0.75,
  borderRadius: "10px",
  border: `1px solid ${PANEL.accent.softBorder}`,
  boxShadow: "none",
  "&:hover": {
    bgcolor: PANEL.accent.soft12,
    borderColor: PANEL.accent.main,
    boxShadow: PANEL.accent.shadow25,
  },
  "&:disabled": {
    bgcolor: PANEL.fill.muted,
    color: PANEL.text.label,
    borderColor: PANEL.border,
  },
};

export const panelStatsDoctorFilterCaptionSx = {
  display: "block",
  color: PANEL.text.muted,
  fontWeight: 700,
  fontSize: "0.8rem",
  mb: 0.75,
  lineHeight: 1.35,
};

export const panelStatsChartEmptyStateSx = {
  py: 4,
  px: 2,
  textAlign: "center",
  borderRadius: PANEL.radius.input,
  bgcolor: PANEL.fill.muted,
  border: `1px dashed ${PANEL.border}`,
};

export const panelStatsChartEmptyTextSx = {
  color: PANEL.text.muted,
  lineHeight: 1.6,
  fontSize: "0.9rem",
};

/** İstatistik sayfası üst başlık */
export const panelStatsPageHeaderSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
  mb: 3,
};

export const panelStatsPageTitleSx = {
  fontWeight: 800,
  color: PANEL.text.primary,
  fontSize: { xs: "1.35rem", md: "1.75rem" },
  lineHeight: 1.2,
  mb: 0,
};

export const panelStatsPageSubtitleSx = {
  color: PANEL.text.muted,
  mt: 0.5,
  fontSize: "0.9rem",
  lineHeight: 1.45,
};

/** Grafik kartı */
export const panelStatsChartCardSx = {
  ...panelTableCardSx,
  mt: 2,
};

export const panelStatsChartCardHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 2,
  mb: 2.5,
};

export const panelStatsChartTitleSx = {
  fontWeight: 700,
  color: PANEL.text.primary,
  fontSize: { xs: "1.05rem", md: "1.15rem" },
};

export const panelStatsChartToggleGroupSx = {
  p: 0.35,
  borderRadius: PANEL.radius.input,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
  "& .MuiToggleButtonGroup-grouped": {
    border: "none !important",
    borderRadius: "10px !important",
    mx: 0.2,
    px: 1.5,
    py: 0.65,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.8125rem",
    color: PANEL.text.muted,
    gap: 0.5,
    "&.Mui-selected": {
      bgcolor: `${PANEL.surface} !important`,
      color: `${PANEL.accent.text} !important`,
      boxShadow: PANEL.shadow.card,
    },
    "&:not(.Mui-selected):hover": {
      bgcolor: PANEL.accent.soft12,
      color: PANEL.text.body,
    },
  },
};

export const panelStatsReadonlyPickerFieldSx = {
  ...panelStatsFilterFieldInnerSx,
  "& .MuiInputBase-input": { cursor: "pointer" },
};

/** Özet metrik kartları */
export const panelStatsSummaryCardSx = {
  height: "100%",
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
};

export const panelStatsSummaryCardRankedSx = (index = 0) => {
  const rank = getPanelStepRank(index);
  return {
    ...panelStatsSummaryCardSx,
    border: `1px solid ${rank.border}`,
    borderTop: `3px solid ${rank.main}`,
    bgcolor: rank.soft,
  };
};

export const panelStatsSummaryLabelSx = {
  color: PANEL.text.muted,
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "none",
  letterSpacing: 0.5,
  mb: 0.75,
};

export const panelStatsSummaryLabelRankedSx = (index = 0) => ({
  ...panelStatsSummaryLabelSx,
  color: getPanelStepRank(index).text,
});

export const panelStatsSummaryValueSx = {
  fontWeight: 800,
  color: PANEL.text.primary,
  fontSize: "1.65rem",
  lineHeight: 1.1,
};

export const panelStatsComparisonCardSx = {
  ...panelTableCardSx,
  bgcolor: PANEL.fill.muted,
};

/** Ek alan ilişki paneli */
export const panelStatsRelationshipCardSx = {
  ...panelTableCardSx,
  p: { xs: 2, md: 2.5 },
  mb: 2.5,
};

export const panelStatsRelationshipFieldBoxSx = {
  p: 1.75,
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  "&:focus-within": {
    borderColor: PANEL.accent.softBorder45,
    boxShadow: PANEL.shadow.inputFocus,
  },
};

export const panelStatsNoteTextSx = {
  color: PANEL.text.muted,
  mb: 2,
  px: 0.5,
  fontSize: "0.875rem",
  lineHeight: 1.5,
};

/** Kohort / ek alan mini grafikleri — Recharts tema */
export const PANEL_EXTRA_FIELD_CHART = {
  grid: PANEL_CHART.grid,
  axis: PANEL_CHART.axis,
  barPrimary: PANEL.accent.main,
  barSecondary: PANEL.blue.main,
  tooltipBg: PANEL_CHART.tooltipBg,
  tooltipBorder: PANEL_CHART.tooltipBorder,
  tooltipText: PANEL.text.primary,
  empty: PANEL.text.muted,
  loading: PANEL.accent.main,
};

/** PatientStatistics + AI/kohort alt bileşenleri — legacy colors API (açık panel) */
export const panelPatientStatsColorsShim = {
  grey: {
    100: PANEL.text.primary,
    200: PANEL.text.body,
    300: PANEL.text.muted,
    400: PANEL.text.muted,
    500: PANEL.text.label,
    600: PANEL.border,
    700: PANEL.border,
    800: PANEL.fill.subtle,
  },
  primary: {
    400: PANEL.surface,
    500: PANEL.fill.muted,
    600: PANEL.fill.muted,
    700: PANEL.pageBg,
    800: PANEL.pageBg,
    900: "rgba(15, 23, 42, 0.08)",
  },
  blueAccent: {
    300: PANEL.blue.text,
    400: PANEL.blue.main,
    500: PANEL.blue.main,
    600: PANEL.blue.main,
    700: PANEL.blue.soft12,
    800: PANEL.blue.soft12,
  },
  greenAccent: {
    300: PANEL.accent.text,
    400: PANEL.accent.main,
    500: PANEL.accent.main,
    600: PANEL.accent.main,
    700: PANEL.accent.soft18,
    800: PANEL.accent.soft12,
  },
  redAccent: {
    300: PANEL.danger.text,
    400: PANEL.danger.main,
    500: PANEL.danger.main,
  },
};

export const panelPatientStatsFormSwitcherSx = {
  p: { xs: 1.5, sm: 1.75 },
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.fill.muted,
  mb: 2,
};

export const panelPatientStatsFormTabSx = (active) => ({
  all: "unset",
  boxSizing: "border-box",
  width: "100%",
  cursor: "pointer",
  minWidth: 0,
  px: 1.35,
  py: 1.1,
  borderRadius: PANEL.radius.input,
  border: `1px solid ${active ? PANEL.accent.softBorder45 : PANEL.border}`,
  bgcolor: active ? PANEL.accent.soft12 : PANEL.surface,
  boxShadow: active ? PANEL.shadow.card : "none",
  transition: "border-color 0.15s, background 0.15s, box-shadow 0.15s",
  "&:hover": {
    borderColor: PANEL.accent.softBorder,
    bgcolor: active ? PANEL.accent.soft18 : PANEL.fill.muted,
  },
});

export const panelPatientStatsExpandButtonSx = {
  width: 36,
  height: 36,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
  color: PANEL.text.body,
  borderRadius: PANEL.radius.input,
  "&:hover": {
    bgcolor: PANEL.accent.soft12,
    borderColor: PANEL.accent.softBorder,
    color: PANEL.accent.text,
  },
};

/** StatsFilters — kart başlık bandı */
export const panelStatsFilterCardHeaderSx = {
  px: { xs: 2, md: 2.5 },
  py: 1.75,
  borderBottom: `1px solid ${PANEL.border}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  flexWrap: "wrap",
  bgcolor: PANEL.surface,
};

export const panelStatsFilterSubtitleSx = {
  color: PANEL.text.muted,
  fontSize: "0.8125rem",
  lineHeight: 1.45,
  mt: 0.25,
};

export const panelStatsFilterGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))",
  },
  gap: 2,
  alignItems: "start",
};

export const panelStatsFilterSummaryBarSx = {
  mt: 2,
  pt: 2,
  borderTop: `1px solid ${PANEL.border}`,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 1,
};

export const panelStatsFilterSummaryLabelSx = {
  color: PANEL.text.muted,
  fontSize: "0.75rem",
  fontWeight: 600,
  mr: 0.5,
};

export const panelStatsFilterApplyButtonSx = {
  ...panelPrimaryButtonSx,
  px: 2,
  py: 0.75,
  minHeight: 40,
};
